<template>

    <div>

        <h2>Cena</h2>
        <div class="price-range-wrap">
            <div class="inputs">

                <div class="item">
<!--                    <input type="text"-->
<!--                           :value="value[0] + '€'"-->
<!--                           class="price-min"-->
<!--                           :min="this.sum.min"-->
<!--                           @change="orderChanged"-->
<!--                    />-->

<!--                    <input type="hidden"-->
<!--                           v-model="value[0]"-->
<!--                           name="min"-->
<!--                           @change="orderChanged"-->
<!--                    />-->

                    <input type="text"
                           v-model="valueMin"
                           name="min"
                           class="price-min"
                           :min="sum.min"
                           @change="orderChanged"
                    />
                </div>

                <div class="item">
<!--                    <input type="text"-->
<!--                           :value="value[1] + '€'"-->
<!--                           class="price-max"-->
<!--                           :max="this.sum.max"-->
<!--                    />-->

<!--                    <input type="hidden"-->
<!--                           v-model="value[1]"-->
<!--                           name="max"-->
<!--                           @change="orderChanged"-->
<!--                    />-->
                    <input
                        type="text"
                        v-model="valueMax"
                        name="max"
                        class="price-max"
                        :max="sum.max"
                        @change="orderChanged"
                    />
                </div>

            </div>

            <vue-slider
                ref="slider"
                v-model="value"
                v-bind="options"
                @drag-end="orderChanged"
            />
        </div>

    </div>

</template>

<script>
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'

    export default {
        props: {
            sum: {
                required: true,
                type: Object
            }
        },

        data () {
            return {
                value: [
                    this.sum.min,
                    this.sum.max
                ],

                ok: false,

                options: {
                    min: this.sum.min,
                    max: this.sum.max,
                    tooltip: 'none',
                    clickable: false
                    // tooltip: 'active',
                    // tooltipPlacement: 'top',
                    // tooltipFormatter: '{value}€',
                    // marks: [this.sum.min, this.sum.max]
                }
            }
        },

        mounted() {
            this.$root.$on('setValuesFromParameters', ( {min, max} ) => {

                if ( min !== undefined && max !== undefined ) {
                    this.value[0] = min;
                    this.value[1] = max;
                    this.$refs.slider.setValue(this.value);
                }

                this.ok = true;
            });
        },

        computed: {
            valueMin: {
                get: function() { if ( this.ok ) return this.value[0] + '€'; },
                set: function( newVal ) {
                    this.value[0] = this.getValue(newVal,'min');
                    this.$refs.slider.setValue(this.value);
                }
            },

            valueMax: {
                get: function() { if ( this.ok ) return this.value[1] + '€' },
                set: function( newVal ) {
                    this.value[1] = this.getValue(newVal, 'max');
                    this.$refs.slider.setValue(this.value);
                }
            },
        },

        components: { VueSlider },

        methods: {
            orderChanged() { setTimeout( () => this.$emit('onOrderChanged'), 50) },

            getValue(newVal, range) {
                if ( range === 'min' )
                    return this.handleMinVal(parseInt(newVal.replace('€', '')));
                else if ( range === 'max' )
                    return this.handleMaxVal(parseInt(newVal.replace('€', '')));
            },

            handleMinVal(newVal) {
                if ( newVal >= this.sum.min ) return newVal;
                else return this.sum.min;
            },

            handleMaxVal(newVal) {
                if ( newVal <= this.sum.max ) return newVal;
                else return this.sum.max;
            }
        },
    }

    // doc: https://nightcatsama.github.io/vue-slider-component/#/api/props
    // exmp: https://jsfiddle.net/NightCatSama/2xy72dod/10520/
    // gh: https://github.com/NightCatSama/vue-slider-component
</script>
